import React, { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslator } from '../../i18n/getTranslator';
import searchTranslations from 'public/locales/en/search.json';
import {
    DropdownWrapper,
    RightWrapper,
    LeftWrapper
} from '../../../search/common/Dropdown.styles';
import { SelectBedsMinOptions } from '../../../search/common/SelectBedsOptions';
import {
    updateFilter,
    bedsMinSelector,
    bedsMaxSelector,
    minPriceSelector,
    maxPriceSelector
} from '../../../reducers/filters';
import {
    FilterWrapper,
    StyledDropdownWithLabel
} from './SearchInitiationMobile.styles';
import { ForSalePriceMaxSelectOptions } from '../../../search/common/SelectPriceOptions';

const t = getTranslator(searchTranslations);
export const SelectBedsPriceForSaleShort = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: bedsMinSelectedValue,
        options: bedsMinOptions
    } = useSelector(bedsMinSelector);
    const { selectedValue: bedsMaxSelectedValue } = useSelector(
        bedsMaxSelector
    );

    const onMinBedsChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        const {
            currentTarget: { value }
        } = evt;

        reduxDispatch(updateFilter('minBedrooms', value));
    };

    const bedsMaxInt = parseInt(bedsMaxSelectedValue, 10);

    const minBedsLabel = t('filters.bedrooms');
    const bedsOptionsLabel = t('filters.field.beds.label');

    const { selectedValue: priceMinSelectedValue } = useSelector(
        minPriceSelector
    );

    const {
        selectedValue: priceMaxSelectedValue,
        options: priceMaxOptions
    } = useSelector(maxPriceSelector);

    const priceMinInt = parseInt(priceMinSelectedValue || '0', 10);

    const onMaxPriceChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('maxPrice', evt.currentTarget.value));
    };

    const priceOptionLabel = t('filters.field.price.label');
    const maxPriceLabel = t('filters.maxPriceLabelModal');

    const bedsMinOptionsShort = bedsMinOptions.map((o) => {
        if (o.label.match(/^\d+$/)) return { ...o, label: o.label + '+' };
        return o;
    });

    return (
        <FilterWrapper>
            <DropdownWrapper>
                <LeftWrapper>
                    <StyledDropdownWithLabel
                        id="mobile_beds_min"
                        onChange={onMinBedsChange}
                        value={bedsMinSelectedValue}
                        name="beds_min"
                        aria-label="Min Beds"
                        data-testid="min_beds_testid_mobile"
                        label={minBedsLabel}
                        hasBorderRadius
                    >
                        {bedsMinOptions ? (
                            <SelectBedsMinOptions
                                bedsOtherInt={bedsMaxInt}
                                options={bedsMinOptionsShort}
                                keyPrefix="modal-min-beds"
                            />
                        ) : (
                            <option>{bedsOptionsLabel}</option>
                        )}
                    </StyledDropdownWithLabel>
                </LeftWrapper>
                <RightWrapper>
                    <StyledDropdownWithLabel
                        id="price_max_mobile"
                        onChange={onMaxPriceChange}
                        value={priceMaxSelectedValue}
                        name="price_max"
                        aria-label="Max Price"
                        data-testid="max_price_testid_mobile"
                        label={maxPriceLabel}
                        hasBorderRadius
                    >
                        {priceMaxOptions ? (
                            <ForSalePriceMaxSelectOptions
                                options={priceMaxOptions}
                                priceOtherInt={priceMinInt}
                                keyPrefix="modal-pricemax"
                            />
                        ) : (
                            <option key="modal-price_max">
                                {priceOptionLabel}
                            </option>
                        )}
                    </StyledDropdownWithLabel>
                </RightWrapper>
            </DropdownWrapper>
        </FilterWrapper>
    );
};
